import { useSearchParams } from 'react-router-dom';
import Header from './Header.js';
import Footer from './Footer.js';
import Modal from './Modal.js';

function Thanks() {
  const [searchParams, setSearchParams] = useSearchParams();
  const name = searchParams.get('name');
  return (
    <div className=" wrapper">
      <Header/>
      <main className="page">
        <section className="success">
            <div className="container success__content">
                <div className="success__info">
                    <h1 className="success__title">
                        <span className="success__title-name">{name}</span>, благодарим Вас за обращение в компанию <span
                            className="success__title-bord">Topkids©</span>
                    </h1>
                    <p className="success__text">
                        Для обсуждения сотрудничества мы свяжемся с вами в ближайшее время.
                    </p>
                    <div className="time success__time">
                        <h3 className="time__title">
                            <span className="time__title-text">График работы:</span>
                            <span className="time__title-days">С понедельника по пятницу</span>
                        </h3>
                        <div className="time__block">
                            <div className="time__item">
                                <div className="time__text">По нашему местному времени в г. Благовещенск: </div>
                                <span className="time__nums">с 9:00 до 18:00</span>
                            </div>
                            <div className="time__item">
                                <div className="time__text">По московскому времени:</div>
                                <span className="time__nums">с 3:00 до 12:00</span>
                            </div>
                        </div>
                    </div>
                    <p className="success__text">
                        Если Вы оставили заявку в нерабочее время или в выходной/праздничный день — мы перезвоним
                        Вам в ближайший рабочий день.
                    </p>
                    <p className="success__text">А пока познакомьтесь ближе с компанией</p>
                    <div className="success-contacts success__contacts">
                        <div className="success-contacts__block">
                            <div className="success-contacts__text success-contacts__text--soc">О жизни проекта в
                                соц.сетях:
                            </div>
                            <ul className="success-contacts__social social list-reset">
                                <li className="social__item">
                                    <a href="https://www.instagram.com/topkids_blg/" target="_blank"
                                        className="social__link social__link--insta"
                                        aria-label="Наша страничка в Инстаграме"></a>
                                </li>
                                <li className="social__item">
                                    <a href="https://t.me/topkids_blg" target="_blank"
                                        className="social__link social__link--fb"
                                        aria-label="Наш Телеграм канал"></a>
                                </li>
                            </ul>
                        </div>
                        <div className="success-contacts__block">
                            <div className="success-contacts__text success-contacts__text--site">Главный сайт бренда:
                            </div>
                            <div className="success-contacts__site site">
                                <a target="_blank" href="http://topkids-center.ru/" className="site__logo">
                                    <picture className="site__photo">
                                        <source srcSet="/img/logo.avif" type="image/avif"/>
                                        <source srcSet="/img/logo.webp" type="image/webp"/>
                                        <img loading="lazy" src="/img/logo.png" alt="Логотип"/>
                                    </picture>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="success__back">
                        Вернуться на основную страницу <a target="_blank"
                            href="http://topkids-center.ru/">http://topkids-center.ru/</a>
                    </div>
                    <div className="success__label">
                        Миссия: обеспечить для каждой семьи доступность и удобство качественного дошкольного
                        образования, дополнительного образования, присмотра и ухода за детьми дошкольного возраста
                        на высоком уровне
                    </div>
                </div>
                <div className="success__director success-director">
                    <picture className="success-director__photo">
                        <source srcSet="/img/thanks/photo.avif" type="image/avif"/>
                        <source srcSet="/img/thanks/photo.webp" type="image/webp"/>
                        <img loading="lazy" src="/img/thanks/photo.png" alt="Директор"/>
                    </picture>
                    <div className="success-director__info">
                        <div className="success-director__name"><span>Галина Швейкус</span></div>
                        <div className="success-director__position"> <span>основатель компании «Topkids»</span></div>
                    </div>
                </div>
            </div>
        </section>
      <Footer/>
      <Modal/>
    </main>
    <script src="/js/main.js" />
  </div>
  );
}

export default Thanks;
